export default __webpack_public_path__ + "static/media/audio_37_gallinas.47b179de.mp3";